export default __webpack_public_path__ + "static/media/5.c7583b53.png";